export const LOGIN_REQUEST_LOADING = 'LOGIN_REQUEST_LOADING';
export const LOGIN_REQUEST_SUCCESS = 'LOGIN_REQUEST_SUCCESS';
export const LOGIN_REQUEST_FAILED = 'LOGIN_REQUEST_FAILED';

export const MESSAGE_REQUEST_LOADING = 'MESSAGE_REQUEST_LOADING';
export const MESSAGE_REQUEST_SUCCESS = 'MESSAGE_REQUEST_SUCCESS';
export const MESSAGE_REQUEST_FAILED = 'MESSAGE_REQUEST_FAILED';